import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Drawer, Link, Switch, Typography } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { getFromLocalStorage, setToLocalStorage } from '../../utils/storage';
var deleteMatchingCookies = function (stringsToDelete) {
    var cookies = document.cookie.split(';');
    for (var _i = 0, cookies_1 = cookies; _i < cookies_1.length; _i++) {
        var cookie = cookies_1[_i];
        var trimmedCookie = cookie.trim();
        var eqPos = trimmedCookie.indexOf('=');
        var name_1 = eqPos > -1 ? trimmedCookie.substr(0, eqPos) : trimmedCookie;
        for (var _a = 0, stringsToDelete_1 = stringsToDelete; _a < stringsToDelete_1.length; _a++) {
            var str = stringsToDelete_1[_a];
            if (name_1.includes(str)) {
                document.cookie =
                    name_1 + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
                break;
            }
        }
    }
};
export var CookiesBanner = function (_a) {
    var show = _a.show, cookies = _a.cookies, productName = _a.productName, removeCookies = _a.removeCookies, onInit = _a.onInit, onChange = _a.onChange, onClose = _a.onClose;
    var _b = useState(false), showCustomizeView = _b[0], setShowCustomizeView = _b[1];
    var _c = useState(cookies), internalCookies = _c[0], setInternalCookies = _c[1];
    var localStorageKey = productName + '-cookies-set';
    var handleOnChange = useCallback(function (key) {
        var newCookies = __assign({}, cookies);
        setInternalCookies(function (oldState) {
            newCookies[key].value = !oldState[key].value;
            onChange === null || onChange === void 0 ? void 0 : onChange(newCookies);
            return __assign(__assign({}, oldState), newCookies);
        });
    }, [cookies, onChange]);
    var handleSaveOrAcceptAll = useCallback(function () {
        var newCookies = __assign({}, cookies);
        for (var _i = 0, _a = Object.keys(cookies); _i < _a.length; _i++) {
            var cookieKey = _a[_i];
            newCookies[cookieKey].value = !showCustomizeView
                ? true
                : internalCookies[cookieKey].value;
        }
        setToLocalStorage(localStorageKey, newCookies);
        onClose === null || onClose === void 0 ? void 0 : onClose(newCookies);
    }, [localStorageKey, showCustomizeView, internalCookies, cookies, onClose]);
    var handleReject = useCallback(function () {
        var newCookies = __assign({}, cookies);
        for (var _i = 0, _a = Object.keys(cookies); _i < _a.length; _i++) {
            var cookieKey = _a[_i];
            newCookies[cookieKey].value = false;
        }
        setToLocalStorage(localStorageKey, newCookies);
        setInternalCookies(newCookies);
        onClose === null || onClose === void 0 ? void 0 : onClose(newCookies);
    }, [cookies, localStorageKey, onClose]);
    var localStorageCookies = getFromLocalStorage(localStorageKey);
    useEffect(function () {
        onInit === null || onInit === void 0 ? void 0 : onInit(localStorageCookies);
    }, [localStorageCookies, onInit]);
    if (!show || !!localStorageCookies) {
        return null;
    }
    if ((removeCookies === null || removeCookies === void 0 ? void 0 : removeCookies.length) && document.cookie) {
        deleteMatchingCookies(removeCookies);
    }
    return (_jsx(Drawer, __assign({ anchor: "bottom", open: show, disableEscapeKeyDown: true }, { children: _jsxs(Box, __assign({ display: "flex", flexDirection: "column", p: 4 }, { children: [showCustomizeView ? (_jsx(Box, __assign({ display: "flex", flexDirection: "column" }, { children: Object.entries(internalCookies).map(function (_a) {
                        var key = _a[0], cookie = _a[1];
                        return (_jsxs(Box, __assign({ display: "flex", alignItems: "center", mb: 3 }, { children: [_jsxs(Box, __assign({ display: "flex", flexDirection: "column", width: "90%" }, { children: [_jsx(Typography, __assign({ variant: "h5" }, { children: cookie.title })), _jsx(Typography, __assign({ variant: "body1" }, { children: cookie.description }))] })), _jsx(Box, __assign({ display: "flex" }, { children: _jsx(Switch, { checked: cookie.value, onChange: function () { return handleOnChange(key); }, disabled: cookie.required }) }))] }), key));
                    }) }))) : (_jsx(Box, __assign({ display: "flex", justifyContent: "center" }, { children: _jsxs(Typography, __assign({ variant: "body1" }, { children: ["We use cookies to enhance your browsing experience and analyze our traffic. By clicking \"Accept All\" you consent to our use of cookies. Read more about our", ' ', _jsx(Link, __assign({ href: "https://www.balena.io/privacy-policy", target: "_blank" }, { children: "privacy policy" })), "."] })) }))), _jsxs(Box, __assign({ display: "flex", mt: 4, ml: "auto", justifyContent: "space-around", width: "400px" }, { children: [_jsx(Button, __assign({ variant: "outlined", onClick: handleReject }, { children: "Reject all" })), _jsx(Button, __assign({ variant: "outlined", onClick: function () { return setShowCustomizeView(!showCustomizeView); } }, { children: showCustomizeView ? 'Back' : 'Customize' })), _jsx(Button, __assign({ variant: "contained", onClick: handleSaveOrAcceptAll }, { children: showCustomizeView ? 'Save selection' : 'Accept all' }))] }))] })) })));
};
